document.addEventListener('DOMContentLoaded', () => {
  const range = document.getElementById('toc-content-wrapper');
  if (!range) {
    return;
  }
  const heads = range.querySelectorAll('h2');
  const ul = document.getElementById('shopify-toc'); // 目次が生成される要素

  let contents = '';
  heads.forEach((head, i) => {
    contents += `<li><a href="#head${i}">${head.textContent}</a></li>`;
    let aTag = document.createElement('a');
    aTag.setAttribute('id', `head${i}`);
    aTag.classList.add('toc-jumppoint');
    head.insertAdjacentElement('afterbegin', aTag);
  });

  ul.innerHTML += `<ul class="toc-wrapper"><p>目次</p>${contents}</ul>`;
});
